import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getTokensToDisplay,
  getAverageServiceTime,
  setDefaultOrganization,
} from '../../../state/token';
import { showSuccessToast } from '../../../state/toasts';
import { OrganizationService } from '../../../services';
import { Organization } from './types';

export function useTokenData(
  displayTokens: any[],
  organization: Organization | undefined,
  geoLocation: any
) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!displayTokens && organization) {
      dispatch(getTokensToDisplay(organization));
      dispatch(getAverageServiceTime(organization));
    }
  }, [displayTokens, organization]);

  useEffect(() => {
    if (!organization && geoLocation) {
      new OrganizationService().guess_my_location(geoLocation).then((res) => {
        dispatch(setDefaultOrganization(res));

        dispatch(showSuccessToast('Success', `Default location set to ${res.code}`));
      });
    }
  }, [organization, geoLocation]);
}
